import type { FolderSource, LocationOccupancyMode } from './properties'
import type { OrgType } from './persona'
import type { HuntingUnit } from './properties'

export type StandType =
  | 'tree_stand'
  | 'ladder_stand'
  | 'box_stand'
  | 'ground_blind'
  | 'climbing_stand'
  | 'tower'
  | 'tripod'
  | 'other'

export type Stand = {
  id: string
  orgId: string
  orgType?: OrgType
  propertyId?: string
  zoneId?: string
  createdBy: string
  folderId?: string
  folderDetached?: boolean
  effectiveFolderId?: string
  folderSource?: FolderSource
  name: string
  description?: string
  standType: StandType
  heightFeet?: number
  capacity?: number
  occupancyMode?: LocationOccupancyMode
  maxGroups?: number
  latitude?: number
  longitude?: number
  directionFacing?: string
  color?: string
  notes?: string
  isActive: boolean
  huntingUnitId?: string
  huntingUnit?: HuntingUnit
  createdAt: string
  updatedAt: string
}

export type StandWithZoneName = Stand & {
  zoneName?: string
}

export type CreateStandInput = {
  orgId: string
  orgType: OrgType
  propertyId?: string
  zoneId?: string
  folderId?: string
  name: string
  description?: string
  standType: StandType
  heightFeet?: number
  capacity?: number
  occupancyMode?: LocationOccupancyMode
  maxGroups?: number | null
  latitude?: number
  longitude?: number
  directionFacing?: string
  color?: string
  notes?: string
  isActive?: boolean
}

export type UpdateStandInput = {
  zoneId?: string | null
  propertyId?: string | null
  folderId?: string | null
  folderDetached?: boolean
  name?: string
  description?: string
  standType?: StandType
  heightFeet?: number
  capacity?: number
  occupancyMode?: LocationOccupancyMode
  maxGroups?: number | null
  latitude?: number
  longitude?: number
  directionFacing?: string
  color?: string | null
  notes?: string
  isActive?: boolean
}

export const STAND_TYPE_OPTIONS: { value: StandType; label: string }[] = [
  { value: 'tree_stand', label: 'Tree Stand' },
  { value: 'ladder_stand', label: 'Ladder Stand' },
  { value: 'box_stand', label: 'Box Stand' },
  { value: 'ground_blind', label: 'Ground Blind' },
  { value: 'climbing_stand', label: 'Climbing Stand' },
  { value: 'tower', label: 'Tower' },
  { value: 'tripod', label: 'Tripod' },
  { value: 'other', label: 'Other' },
]
